import { Image, LI, Btn } from "../../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { dynamicImage } from "../../../../Service";
import ProfileBox from "./ProfileBox";

import { useAuth } from "../../../../context/AuthContext";
const UserProfile = () => {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();
  return (
    <>
      <LI className="profile-nav onhover-dropdown">
        <Btn
          size="sm"
          outline
          color="primary"
          className="btn-pill"
          onClick={logoutUser}
        >
          Logout
        </Btn>
        {/* <ProfileBox /> */}
      </LI>
    </>
  );
};

export default UserProfile;
